import * as z from 'zod';

// Types
import { TagZod } from '@/types/TagType';
import { CTAZod } from '@/types/CTAType';
import { TitleZod } from '@/types/TitleType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

const OfferZod = z.object({
  id: z.number(),
  slug: z.string(),
  titleOverview: TitleZod,
  paragraphOverview: ParagraphZod,
  labelOverview: z.string(),
  tags: z.array(TagZod).nullable(),
});

export type OfferType = z.infer<typeof OfferZod>;

const OffersZod = z.object({
  __component: z.literal('block.offers'),
  id: z.number(),
  title: TitleZod,
  cta: CTAZod.nullable(),
  offers: z.array(OfferZod).nullable(),
  waveWrapper: WaveWrapperZod.nullable(),
});

export { OffersZod };
export type OffersType = z.infer<typeof OffersZod>;
